import { isCtaEnabledForDeployment } from '#pplx/frontend/apps/ask/upsell-slots/actions/ctaCapabilities.js';
/**
 * Returns the handler loader for a given CTA.
 * Using dynamic imports to enable code splitting.
 */
function getCtaHandlerLoader(cta) {
    if (!isCtaEnabledForDeployment(cta))
        return undefined;
    switch (cta) {
        // Subscription handlers
        case 'SIGN_UP_OR_LOGIN':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleSignUpOrLogin.js').then((m) => m.handleSignUpOrLogin);
        case 'PRO_UPGRADE':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleProUpgrade.js').then((m) => m.handleProUpgrade);
        case 'ADD_CREDITS':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleAddCredits.js').then((m) => m.handleAddCredits);
        case 'EXPRESS_ADD_CREDITS':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleExpressAddCredits.js').then((m) => m.handleExpressAddCredits);
        case 'COMPUTER_TRIAL_OFFER':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleComputerTrialOffer.js').then((m) => m.handleComputerTrialOffer);
        case 'COMPUTER_EDUCATIONAL_MODAL':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleComputerEducationalModal.js').then((m) => m.handleComputerEducationalModal);
        case 'ACKNOWLEDGE':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleAcknowledgeUpsell.js').then((m) => m.handleAcknowledgeUpsell);
        case 'SUBSCRIPTION_PROMO':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleSubscriptionPromo.js').then((m) => m.handleSubscriptionPromo);
        case 'OPEN_SHEERID_MODAL':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleOpenSheerIdModal.js').then((m) => m.handleOpenSheerIdModal);
        case 'OPEN_ENTERPRISE_CONCIERGE_MODAL':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleOpenEnterpriseConciergeModal.js').then((m) => m.handleOpenEnterpriseConciergeModal);
        case 'OPEN_VIP_ADVISOR_MODAL':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleOpenVipAdvisorModal.js').then((m) => m.handleOpenVipAdvisorModal);
        // Browser agent handlers
        case 'SKIP_BROWSER_AGENT':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleSkipBrowserAgent.js').then((m) => m.handleSkipBrowserAgent);
        case 'SKIP_COMPLEX_QUERY_COMPUTER_REWRITE':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleSkipComplexQueryComputerRewrite.js').then((m) => m.handleSkipComplexQueryComputerRewrite);
        case 'ALLOW_BROWSER_AGENT_ONCE':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleAllowBrowserAgentOnce.js').then((m) => m.handleAllowBrowserAgentOnce);
        case 'ALWAYS_ALLOW_BROWSER_AGENT':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleAlwaysAllowBrowserAgent.js').then((m) => m.handleAlwaysAllowBrowserAgent);
        case 'SWITCH_TO_CONTROL_BROWSER':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleSwitchToControlBrowser.js').then((m) => m.handleSwitchToControlBrowser);
        case 'CONNECT_LOCAL_BROWSER':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleConnectLocalBrowser.js').then((m) => m.handleConnectLocalBrowser);
        // Canvas handlers
        case 'CONTINUE_GENERATION':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleContinueGeneration.js').then((m) => m.handleContinueGeneration);
        case 'NO_CANVAS_GENERATION':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleNoCanvasGeneration.js').then((m) => m.handleNoCanvasGeneration);
        // Connector handlers
        case 'CONNECTOR':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleConnector.js').then((m) => m.handleConnector);
        case 'MERGE_AUTH_CONNECTOR':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleMergeAuthConnector.js').then((m) => m.handleMergeAuthConnector);
        // Shopping handlers
        case 'VIRTUAL_TRY_ON_ONBOARDING_MODAL':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleVirtualTryOnOnboardingModal.js').then((m) => m.handleVirtualTryOnOnboardingModal);
        // Download handlers
        case 'COMET_DOWNLOAD':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleCometDownload.js').then((m) => m.handleCometDownload);
        case 'COMET_DOWNLOAD_1MO_PRO_INCENTIVE':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleCometDownload1moProIncentive.js').then((m) => m.handleCometDownload1moProIncentive);
        case 'SET_DEFAULT_BROWSER':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleSetDefaultBrowser.js').then((m) => m.handleSetDefaultBrowser);
        // Content handlers
        case 'THREAD_TO_SPACE':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleThreadToSpace.js').then((m) => m.handleThreadToSpace);
        case 'REWRITE_ANSWER':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleRewriteAnswer.js').then((m) => m.handleRewriteAnswer);
        case 'PERMALINK':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handlePermalink.js').then((m) => m.handlePermalink);
        case 'RUN_IN_COMPUTER':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleRunInComputer.js').then((m) => m.handleRunInComputer);
        case 'TOGGLE_SOURCES':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleToggleSources.js').then((m) => m.handleToggleSources);
        case 'FULLSCREEN_MODAL':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleFullscreenModal.js').then((m) => m.handleFullscreenModal);
        case 'SHARE_LOCATION':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleShareLocation.js').then((m) => m.handleShareLocation);
        // advanced search handlers
        case 'ADVANCED_SEARCH_CHECKOUT':
            return () => import('#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/handleAdvancedSearchCheckoutModal.js').then((m) => m.handleAdvancedSearchCheckout);
        default:
            return undefined;
    }
}
// CTAs dispatched in useUpsellActions outside getCtaHandlerLoader (complex hook
// dependencies keep them inline). Kept here so isCtaSupported stays in sync with
// everything the client can actually act on. Typed via `new Set<UpsellCTA>` so the
// members are checked against the enum, but stored as ReadonlySet<string> so lookups
// accept the possibly-unknown runtime cta.
const CTAS_HANDLED_OUTSIDE_LOADER = new Set([
    'ALLOW_CONNECTOR_AUTH',
]);
/**
 * Whether THIS client build can act on the given CTA.
 *
 * Backend/frontend version drift: enums are delivered as JSON strings, so when a
 * newer backend emits a CTA that predates this (cached or not-yet-updated) bundle,
 * `cta` arrives as a raw string with no matching handler. Rendering it produces a
 * dead button. Use this to suppress such upsells at render-decision time, mirroring
 * the iOS client which hides upsells with unrecognized CTAs.
 *
 * Callers must guard on `cta` presence themselves: action-less upsells (no cta —
 * e.g. the Comet NTP mobile-download QR card) are intentional and must still render.
 *
 * `extraSupportedCtas` covers slots that inject customHandlers (see
 * ModalUpsellSlot) for CTAs not in the global loader.
 *
 * `cta` is typed `string`, not `UpsellCTA`, on purpose: the value being checked is the
 * possibly-unknown runtime cta from the backend, which is exactly what this guards
 * against. An out-of-union value resolves correctly — the loader switch hits `default`
 * → undefined and the Set/array lookups return false.
 */
export function isCtaSupported(cta, extraSupportedCtas = []) {
    if (!isCtaEnabledForDeployment(cta))
        return false;
    if (cta === 'CONNECT_LOCAL_BROWSER')
        return extraSupportedCtas.includes(cta);
    if (getCtaHandlerLoader(cta) !== undefined)
        return true;
    if (CTAS_HANDLED_OUTSIDE_LOADER.has(cta))
        return true;
    return extraSupportedCtas.includes(cta);
}
/**
 * Execute a CTA handler with the given context.
 * Returns true if the handler was found and executed, false otherwise.
 */
export async function executeCtaHandler(ctx) {
    if (!ctx.upsellInformation.cta)
        return false;
    const handlerLoader = getCtaHandlerLoader(ctx.upsellInformation.cta);
    if (!handlerLoader)
        return false;
    const handler = await handlerLoader();
    await handler(ctx);
    return true;
}
//# sourceMappingURL=executeCtaHandler.js.map